import { CrmAddonGate } from '@/pages/crm/addon/AddonGate';
import { LeadDetailPage } from '@/pages/crm/leads/LeadDetailPage';
import { createFileRoute } from '@tanstack/react-router';

// Addon-off resolves to the B1 upsell teaser without fetching any Lead data: the gate
// only renders the detail container when the tenant is entitled (addon OR chain).
function LeadDetailRoute() {
	return (
		<CrmAddonGate>
			<LeadDetailPage />
		</CrmAddonGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/crm/leads/$leadId')({
	component: LeadDetailRoute,
});
